import { API_Data_Memberships_Response } from "@/interfaces/api/memberships/api_response_types"
import { API_Error, API_Response } from "@/interfaces/api/response/api_response_types"
import { fetcher } from "@/utils/helpers"

/*
==================
      MEMBERSHIPS
==================
*/

/**
 * Fetches the available memberships from the server API
 * 
 * @param locale - Fetches the available memberships from the backend API
 * @returns A promise resolving to the memberships response data
 * @throws API_Error if the request fails or the response is invalid
 */
export async function getMemberships(locale: string, code?: string): Promise<API_Data_Memberships_Response> {
  const res = await fetcher(`/api/memberships?lang=${locale}${code ? `&code=${code}` : ''}`, {
    method: 'GET',
    cache: "no-store",
    credentials: 'include',
  })
  const response = await res.json() as API_Response<API_Data_Memberships_Response>
  
  if (!res.ok) throw { code: res.status, description: 'Unknow memberships error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Memberships data missing in response' } as API_Error

  return response.data
}